import _debounce from 'lodash/debounce';
import React, { useState } from 'react';
import { getApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import ShortLinkDropdown from '../../../components/DropDown/ShortLinkDropdown';
import IconButton from '../../../components/Buttons/IconButton';
import { IconX } from '@tabler/icons-react';

const AddLinkToBlock = () => {

    const [linkTypeRadio, setLinkTypeRadio] = useState('new');
    const [linkList, setLinkList] = useState([]);
    const [searchInput, setSearchInput] = useState('');

    async function getList(e) {
        setSearchInput(e.target.value);
        let resp = await getApi(urlApi.searchActiveLinks + "?search=" + e.target.value);
        setLinkList(resp?.data || []);
    }

    function onSelectLink(linkData) {
        document.getElementById('destinationUrl').value = linkData.mainLink;
        document.getElementById('search-existing-link-input').value = linkData.shortLink;
        setLinkList([])
    }

    function onCancel() {
        document.getElementById('destinationUrl').value = '';
        document.getElementById('search-existing-link-input').value = '';
        setLinkList([]);
        setSearchInput('');
    }

    return (
        <div>
            <div className="flex gap-5 my-3">
                <div className='flex items-center'>
                    <input type="radio" name="link-type-radio-btn" id="link-type-new" onChange={(e) => e.target.checked && setLinkTypeRadio('new')} defaultChecked={linkTypeRadio == "new"} />
                    <label htmlFor="link-type-new" className="ml-2 font-medium">Create New Link</label>
                </div>
                <div className='flex items-center'>
                    <input type="radio" name="link-type-radio-btn" id="link-type-existing" onChange={(e) => e.target.checked && setLinkTypeRadio('existing')} defaultChecked={linkTypeRadio == "existing"} />
                    <label htmlFor="link-type-existing" className="ml-2 font-medium">Select Existing Link</label>
                </div>
            </div>

            {
                linkTypeRadio == 'new' && <div>
                    <div className='mb-4'>
                        <label htmlFor="" className='mb-1 font-semibold'>Destination URL</label>
                        <input type="text" className="form-control w-full" id='destinationUrl' placeholder="Enter Link URL" />
                    </div>
                    <div className='flex flex-col'>
                        <ShortLinkDropdown />
                    </div>
                </div>
            }
            {
                linkTypeRadio == 'existing' && <div className='relative'>
                    <div className='mb-2'>
                        <label htmlFor="" className='mb-1 font-semibold'>Select a Attriva link</label>
                        <input type="text" className="hidden" id='destinationUrl' placeholder="Enter Link URL" />
                        <div className='flex'>
                            <input type="text" className="form-control w-full" placeholder="Search by back-half, destination, or title" defaultValue={searchInput} onChange={_debounce((e) => getList(e), 300)} id='search-existing-link-input' />
                            {searchInput && <IconButton icon={< IconX />} onClickFunction={() => onCancel()} />}
                        </div>
                    </div>
                    {linkList?.length > 0 && <div className="w-full max-h-[300px] overflow-y-auto absolute bg-white z-20 shadow-md p-2 rounded-lg">
                        {
                            linkList.map((link, index) => (
                                <div key={index} className='border p-2 rounded-lg mb-2 cursor-pointer' onClick={() => onSelectLink(link)}>
                                    <p className='text-sm font-medium mb-0'>{link.shortLink}</p>
                                    <p className='text-xs font-normal mb-0'>{link.mainLink}</p>
                                </div>
                            ))
                        }
                    </div>}
                </div>
            }
        </div>
    )
}

export default AddLinkToBlock